import React from 'react'

import { AnalyticsDataLabel } from '../AnalyticsDataLabel/AnalyticsDataLabel'
import { analyticsPaymentMethodLabelIcons } from './AnalyticsPaymentMethodLabel.consts'
import type { AnalyticsPaymentMethodLabelType } from './AnalyticsPaymentMethodLabel.types'

type AnalyticsPaymentMethodLabelProps = {
  type: AnalyticsPaymentMethodLabelType
}

export const AnalyticsPaymentMethodLabel = ({ type }: AnalyticsPaymentMethodLabelProps) => {
  return (
    <AnalyticsDataLabel
      label={type}
      icon={{
        src: analyticsPaymentMethodLabelIcons[type] ?? analyticsPaymentMethodLabelIcons.CARD,
        width: 30,
        aspectRatio: 30 / 20,
      }}
    />
  )
}
